import TitledRange from "./TitledRange.js";

export default TitledRange;
